export default class CertEquivalency {
  constructor(API) {
    this.api = API;
  }
  async createCertEquivalency(certificationID, equivalencyObj, type) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/certification/${certificationID}/equivalence/new/type/${type}`;
    req.body = equivalencyObj;
    return await req.exec();
  }
  async updateCertEquivalency(certificationID, equivalencyObj, type) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = `/certification/${certificationID}/equivalence/${equivalencyObj.id}/type/${type}`;
    req.body = equivalencyObj;
    return await req.exec();
  }
  async deleteCertEquivalency(certificationID, equivalencyID, type) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = `/certification/${certificationID}/equivalence/${equivalencyID}/type/${type}`;
    return await req.exec();
  }
  async getCertEquivalency(certificationID, equivalencyID, type) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/certification/${certificationID}/equivalence/${equivalencyID}/type/${type}`;
    return await req.exec();
  }
  async getCertEquivalences(certificationID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/certification/${certificationID}/equivalences`;
    return await req.exec();
  }
}
